import request from '@/api/config/request'

const prex = "/api/admin/gestao/fiscalizacao/simples_nacional";

export function list_simples_nacional_potencial() {
    return request({
        url: `${prex}`,
        method: 'get'
    })
}